import Image from 'next/image';

import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Box } from '../Box';
import { Text } from '../Text';
import Link from '../Link';
import { Flexbox } from '../Flexbox';

export const Block = styled('ul')`
  padding-left: 0;
`;

export const BlockHeading = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing.ml};
  max-width: ${pxToRem(92)};

  ${mediaQueries.desktop} {
    margin-bottom: ${({ theme }) => theme.spacing.m};
    margin-left: initial;
    text-align: center;
    max-width: none;
  }
`;

export const CareerBlockIntroText = styled(Box)`
  text-align: left;

  ${mediaQueries.tablet} {
    text-align: center;
  }
`;

export const Department = styled('span')`
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: 600;
  border-top: 1px solid ${({ theme }) => theme.color.white};
  padding: ${({ theme }) => theme.spacing.s} 0;

  a {
    text-decoration: none;
    color: white;
  }

  &:nth-of-type(1) {
    border-top: none;
  }
`;

export const DepartmentContainer = styled(Box)`
  border-radius: ${({ theme }) => theme.borderRadius.block};
  background-color: ${({ theme }) => theme.color.pressPostBg};
  padding: ${({ theme }) => `${theme.spacing.xl} ${theme.spacing.l}`};
  margin: ${({ theme }) => theme.spacing.m} 0;

  ${mediaQueries.desktop} {
    flex-wrap: inherit;
    margin: ${({ theme }) => theme.spacing.ml} 0;
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

export const DropdownButton = styled(Image, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'none')};
  transition: 0.25s transform ease;

  height: ${pxToRem(12)};

  &:hover {
    cursor: pointer;
  }

  ${mediaQueries.desktop} {
    height: ${pxToRem(16)};
  }
`;

export const DropdownHeader = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${({ theme }) => theme.color.white};
  font-weight: 600;
  align-items: center;
  position: relative;
`;

export const DropdownHeadline = styled('a')`
  font-size: ${({ theme }) => theme.fontSize.s};

  &:hover {
    color: ${({ theme }) => theme.color.buttonHover};
  }

  ${mediaQueries.tablet} {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.ml};
  }
`;

export const DropdownWrapper = styled(Flexbox)`
  width: 100%;
  position: absolute;
  z-index: 3;
`;

export const DropdownMenu = styled('div')<{ align?: string }>`
  margin: ${({ theme }) => `0 ${theme.spacing.s}`};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.color.darkButton};
  border-radius: ${({ theme }) => theme.borderRadius.input};
  height: fit-content;
  flex: 1;

  &:hover {
    cursor: pointer;
  }

  ${mediaQueries.tablet} {
    margin: ${({ theme }) => `0 ${theme.spacing.sm}`};
    max-width: ${pxToRem(275)};
  }

  ${mediaQueries.desktop} {
    max-width: ${pxToRem(390)};
    padding: ${({ theme }) => theme.spacing.sm}
      ${({ theme }) => theme.spacing.l};
  }
`;

export const DropdownOptions = styled('div')`
  display: none;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.s} 0 0 0;
  top: 22%;
  background-color: ${({ theme }) => theme.color.darkButton};
`;

export const Icon = styled(Image)`
  display: block;
  height: ${pxToRem(18)};
`;

export const Job = styled(Link)`
  list-style-type: none;
  line-height: ${({ theme }) => theme.spacing.ml};
  margin-bottom: 1rem;
  width: 100%;
  color: ${({ theme }) => theme.color.darkButton};
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: 600;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.color.buttonHover};
  }

  ${mediaQueries.mobile} {
    font-size: ${({ theme }) => theme.fontSize.m};
  }
`;

export const JobListings = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const MenuButton = styled('button')`
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing.xs};

  ${mediaQueries.desktop} {
    display: none;
  }
`;

export const StyledAnchor = styled('a')`
  font-size: ${({ theme }) => theme.fontSize.s};
  line-height: ${({ theme }) => theme.lineHeight.l};
  padding: ${({ theme }) => theme.spacing.sm} 0;

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.color.buttonHover};
  }

  ${mediaQueries.tablet} {
    font-size: ${({ theme }) => theme.fontSize.sm};
    line-height: ${({ theme }) => theme.lineHeight['2xl']};
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.ml};
  }
`;

export const TextWrapper = styled(Box)`
  width: 100%;
  ${mediaQueries.tablet} {
    width: auto;
    margin: auto;
    padding: ${({ theme }) => theme.spacing.ml};
  }
`;

export const Wrapper = styled('div')`
  flex-direction: column;
  margin: auto;
  display: flex;
  width: 100%;
  ${mediaQueries.tablet} {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  ${mediaQueries.desktop} {
    flex-wrap: nowrap;
    justify-content: space-between;
  }
`;
